import { filterContacts } from 'modules/Search'
import { searchContactsFulfilled } from 'redux/Contacts'
import {
  SEARCH,
  SEARCH_KEY_FULFILLED,
  SEARCH_KEY_PENDING,
} from 'redux/Contacts/constants'
import { preparePhoneNumberForCall } from 'n2p-ui-library/utils/phone-number/phone-number.util'

let saveTimer
const debounceTime = 400

const debounce = (dispatch, value) => {
  if (saveTimer) {
    clearTimeout(saveTimer)
  }

  if (!value?.length) {
    dispatch(searchContactsFulfilled([]))
    return
  }

  saveTimer = setTimeout(() => {
    const filteredIds = filterContacts(
      preparePhoneNumberForCall(value) || value,
    )
    dispatch(searchContactsFulfilled(filteredIds))
  }, debounceTime)
}

const actions = [SEARCH, SEARCH_KEY_PENDING, SEARCH_KEY_FULFILLED]

// TODO add immediate for making call before search completes
const SearchMiddleware = () => (dispatch) => (action) => {
  dispatch(action)

  if (actions.includes(action.type) && action?.meta?.search) {
    debounce(dispatch, action.payload)
  }
}

export default SearchMiddleware
